import { AvaliacaoDeliveryInicial, type AvaliacaoDeliveryModel } from "../models/avaliacaoDeliveryModel"
import {
    AvaliacaoDeliveryActionsTypes,
    type AvaliacaoDeliveryActionModel,
} from "./avaliacaoDeliveryActions"

export function avaliacaoDeliveryReducer(
    state: AvaliacaoDeliveryModel,
    action: AvaliacaoDeliveryActionModel
): AvaliacaoDeliveryModel {
    switch (action.type) {
        case AvaliacaoDeliveryActionsTypes.CARREGAR:
            return {
                ...state,
                avaliacoes: action.payload.avaliacoes,
                total: action.payload.total,
                media: action.payload.media,
                nps: action.payload.nps,
            }

        case AvaliacaoDeliveryActionsTypes.ATUALIZAR_INICIO:
            return { ...state, inicioMs: action.payload }

        case AvaliacaoDeliveryActionsTypes.ATUALIZAR_FIM:
            return { ...state, fimMs: action.payload }

        default:
            return state
    }
}

export { AvaliacaoDeliveryInicial }
